import { Pipe, PipeTransform } from '@angular/core';
import { LocationService } from '../services/location.service';

@Pipe({
  name: 'stateFormat',
  standalone: true
})
export class StateFormatPipe implements PipeTransform {
  
  constructor(private locationService: LocationService) {}
  
  transform(sigla: string): string {
    if (!sigla) return '';
    
    const estado = this.locationService.getEstadoBySigla(sigla);
    if (estado) {
      return `${estado.nome} (${sigla})`;
    }
    
    return sigla;
  }
}
